import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqList: FAQItem[] = [
  {
    question: '久久在线是什么平台？',
    answer: '久久在线是一个综合性在线内容平台，提供视频、资讯、娱乐、科技、生活、教育、体育、音乐等八大板块的优质内容，支持网页端和移动端随时随地访问。',
  },
  {
    question: '久久在线的内容是否免费观看？',
    answer: '久久在线提供大量免费内容资源，用户注册后即可免费观看。部分精品内容可能需要会员权限，但我们始终保持大部分内容免费开放，让更多用户享受优质在线体验。',
  },
  {
    question: '如何获取久久在线的最新内容更新？',
    answer: '您可以通过关注久久在线的微信公众号、微博账号或订阅我们的邮件通讯来获取最新内容更新通知。此外，久久在线首页每日更新热门内容和最新文章，方便您随时了解动态。',
  },
  {
    question: '久久在线的视频支持高清播放吗？',
    answer: '是的，久久在线全面支持高清视频播放，最高支持1080P和4K超高清画质。平台采用先进的流媒体技术，确保在各种网络环境下都能流畅播放，为您带来极致的视听体验。',
  },
  {
    question: '久久在线可以在哪些设备上使用？',
    answer: '久久在线支持多种设备访问，包括电脑（Windows/Mac）、平板（iPad/Android平板）和手机（iOS/Android）。无论您使用什么设备，都能获得一致流畅的使用体验。',
  },
  {
    question: '久久在线的内容更新频率如何？',
    answer: '久久在线每日更新大量新鲜内容，覆盖八大内容板块。我们的编辑团队全天候工作，确保用户第一时间获取最新资讯、最热视频和最优质的文章内容。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">常见问题</h2>
          <p className="mt-3 text-foreground-500">关于久久在线，你可能想了解的一些问题</p>
        </div>

        <div className="space-y-3">
          {faqList.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <span className="font-semibold text-foreground-900 text-sm pr-4">{faq.question}</span>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${
                  openIndex === index ? 'bg-primary-100 text-primary-600' : 'bg-background-100 text-foreground-400'
                }`}>
                  <i className={`text-base transition-transform duration-300 ${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-60 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}